export var AttributeKeyForVehicle;
(function (AttributeKeyForVehicle) {
    AttributeKeyForVehicle["PIN_VID"] = "pinVid";
    AttributeKeyForVehicle["NADA_VID"] = "nadaVid";
    AttributeKeyForVehicle["STYLE_ID"] = "styleId";
    AttributeKeyForVehicle["SOURCE_VID"] = "sourceVid";
    AttributeKeyForVehicle["REDBOOK_CONTROL_NUMBER"] = "redbookControlNumber";
})(AttributeKeyForVehicle || (AttributeKeyForVehicle = {}));
//# sourceMappingURL=AttributeKeyForVehicle.js.map